import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'

function ServiceDesThree() {
  return (
    <Container className="p-3">
      <Row style={{ justifyContent: 'center' }} >
        <Row className='mt-3'>
          <Col className='service_des_title' > Abdominal Wall Problems </Col>
        </Row>
        <Row className='mt-3'>
          <Col>
            <p className='service_des_p' >
              The abdominal wall is a layer of muscles and connective tissue, known as the abdominopelvic cavity or abdomino-pelvic cavity. The abdominal wall is one of the most important anatomical structures in the body. It plays an integral role in supporting and protecting many other organs.
            </p>
            <p className='service_des_p'>
              The abdomen is comprised of various layers of tissue, fat, and muscle that protect the organs within the abdominal cavity including the stomach, the kidneys, and the small intestine. The muscles of the abdominal wall stabilize the torso and aid in vital functions such as respiration and urination.
            </p>
            <p className='service_des_p'>
              Sometimes, the wall can become weakened due to the formation of complex hernias and the return of a previously repaired hernia. In these cases, the tissues of the abdominal wall need to be restructured. This is a surgical procedure used to restore the structural and functional integrity of the abdominal muscles.
            </p>
          </Col>
        </Row>
        <Row className='mt-3'>
          <Col className='service_des_title'> Why wall reconstruction is performed </Col>
        </Row>
        <Row className='mt-3'>
          <Col className='service_des_p' >
            <p> This procedure may be recommended for patients who experience the following: </p>
            <ul>
              <li> Recurrent hernias </li>
              <li> Incisional hernia </li>
              <li> Infection that develops after a surgery </li>
              <li> Wound that develops after a hernia repair</li>
            </ul>
            <p> It is most often performed on patients who have had unsuccessful hernia repair operations. The goal of reconstruction is to treat any open wounds in the abdominal wall, restructure the tissues, and reinforce the integrity of the muscles.</p>
          </Col>
        </Row>
      </Row>
    </Container>
  )
}

export default ServiceDesThree